/**
 * @generated SignedSource<<2eb29511dabb63f0649ac9b69851c5ca>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarSellerInfoAndContactLazy_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedSidebarSellerInfoAndContact_item">;
  readonly " $fragmentType": "PdpRespSidebarSellerInfoAndContactLazy_item";
};
export type PdpRespSidebarSellerInfoAndContactLazy_item$key = {
  readonly " $data"?: PdpRespSidebarSellerInfoAndContactLazy_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarSellerInfoAndContactLazy_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarSellerInfoAndContactLazy_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedSidebarSellerInfoAndContact_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "8249908a91e59ed47287c79c5b9a3df5";

export default node;
